<template>
  <div>
    <m-pane
      ref="tablePage"
      class="tablePage"
      :config="config"
      :totalData="totalData"
      :pageTotal="pageTotal"
      :loading="loading"
      pageID="lsrm-changeInformation"
      :currentPage="currentPage"
      @search-btn="handleSearch"
      @checkout-btn="checkout"
      @details-btn="handleDetails"
      @pageChange="pageChange"
      @sizeChange="sizeChange"
      @selectChange="selectChange"
    ></m-pane>
    <change-details-dialog
      v-if='openChangeDetailsDialog'
      :openChangeDetailsDialog.sync="openChangeDetailsDialog"
      :title="title"
      :changeApplyNo="changeApplyNo"
    ></change-details-dialog>
    <change-information-dialog
      @confirmDialog="confirmDialog"
      @closeDialog="closeDialog"
      :openChangeDialog="openChangeDialog"
      :title="'变更申请'"
      :disabled="disabled"
      :disabledSubmit="disabledSubmit"
      :showUpload="showUpload"
      :tableData="tableData"
      :basicForm="basicForm"
      :financeForm="financeForm"
      :bankForm="bankForm"
      :otherForm="otherForm"
      :changeType="changeType"
      :activeName="activeName"
      :supplierTab="supplierTab"
      @submitCallback="submitCallback">
    </change-information-dialog>
  </div>
</template>
<script>
import mPane from '../../../../../components/Table/Index.vue';
import config from './config.json';
import changeInformationDialog from '../../../../../components/changeInformationDialog.vue';
import { getChangeApplyInfos, examineData, supplierBasicSubmit, supplierFinanceSubmit, supplierBankSubmit, otherSubmit } from '../../../../../api/changeDetails.js';
import { dictWithUrl } from '@/components/lots/api';
import changeDetailsDialog from '../../../manage/keyData/tabs/changeInformation/ChangeDetailsDialog.vue';
export default {
    name: 'changeInformation',
    components: { mPane, changeInformationDialog, changeDetailsDialog },
    props: {
        supplierTab: {
            type: Object,
            default() {
                return {
                    supplierCode: '',
                    propertyNature: ''
                };
            }
        }
    },
    data() {
        return {
            config,
            checkedList: [],
            // 表格数据
            totalData: [], // table数据
            pageTotal: 0, // 总条数
            loading: false, // table的loading状态
            currentPage: 1, // 当前页数
            openChangeDialog: false,
            searchParams: {
                pageSize: 10,
                pageNo: 1
            },
            disabled: false,
            disabledSubmit: false,
            openChangeDetailsDialog: false,
            selected: [],
            changeApplyNo: '',
            basicForm: {},
            financeForm: {},
            bankForm: {},
            otherForm: {},
            showUpload: true,
            tableData: [],
            changeType: '',
            activeName: '',
            supplierTab_: {}
        };
    },
    methods: {
        handleSearch() {
            const params = { supplierCode: this.supplierTab_.supplierCode, ...this.searchParams };
            getChangeApplyInfos(params).then(res => {
                if (res && res.code === '0') {
                    this.totalData = this.formatData(res.data.list);
                    this.pageTotal = res.data.totalCount;
                }
            });
        },
        closeDialog(data) {
            this.openChangeDetailsDialog = data;
            this.openChangeDialog = data;
        },
        /** 更多变更明细 **/
        handleDetails() {
            if (this.selected.length === 0) {
                this.$message.warning('当前没有选中的数据');
            } else if (this.selected.length > 1) {
                this.$message.warning('目前只能选择一条数据，请重新确认');
            } else {
                this.changeApplyNo = this.selected[0].changeApplyNo;
                this.title = '查看变更明细';
                this.openChangeDetailsDialog = true;
            }
        },
        /** 查看 **/
        checkout(data) {
            examineData(data.changeApplyNo).then(res => {
                if (res && res.code === '0') {
                    this.changeType = res.data.changeType;
                    const code = {
                        supplierCode: this.supplierTab_.supplierCode,
                        changeApplyNo: data.changeApplyNo
                    };
                    if (res.data.changeType === '1') {
                        this.activeName = '1';
                        this.basicForm = res.data.basicAfter;
                        Object.assign(this.basicForm, code);
                        const tmp = res.data.basicAfter;
                        if (tmp.list) {
                            this.tableData = tmp.list;
                        }
                    } else if (res.data.changeType === '2') {
                        this.activeName = '2';
                        this.financeForm = res.data.financeAfter;
                        Object.assign(this.financeForm, code);
                    } else if (res.data.changeType === '4') {
                        this.activeName = '4';
                        this.bankForm = res.data.bank;
                        Object.assign(this.bankForm, code);
                    } else if (res.data.changeType === '5') {
                        this.activeName = '5';
                        this.otherForm = Object.assign(res.data.otherAfter || {}, { ...code, supplierNameCn: res.data.supplierNameCn });
                    }
                    if (data.changeFlagCn === '驳回') {
                        this.disabled = false;
                        this.disabledSubmit = false;
                    } else {
                        this.disabled = true;
                        this.disabledSubmit = true;
                        this.showUpload = false;
                    }
                    this.openChangeDialog = true;
                }
            });
        },
        /** 提交审批 **/
        submitCallback(data) {
            const func = {
                basicForm: supplierBasicSubmit,
                financeForm: supplierFinanceSubmit,
                bankForm: supplierBankSubmit,
                otherForm: otherSubmit
            };
            func[data.changeType].then(res => {
                if (res && res.code === '0') {
                    this.$message.success('提交成功');
                    this.closeDialog();
                }
            });
        },
        formatData(data) {
            data.map(item => {
                item.changeType = this.dictData.SRM_CHANGE_TYPE[item.changeType];
                item.changeFlag = this.dictData.SRM_CHANGE_STATUS[item.changeFlag];
            });
            return data;
        },
        confirmDialog(data) {},
        selectChange(data) {
            this.selected = [].concat(data);
        },
        pageChange(data) {
            this.searchParams.pageNo = data;
            this.handleSearch();
        },
        sizeChange(data) {
            this.searchParams.pageSize = data;
            this.handleSearch();
        }
    },
    mounted() {
    },
    watch: {
        supplierTab: {
            handler(nVal) {
                if (Object.keys(nVal).length) {
                    this.supplierTab_ = JSON.parse(JSON.stringify(nVal));
                    dictWithUrl('SRM_CHANGE_TYPE,SRM_CHANGE_STATUS').then(res => {
                        if (res && res.code === '0') {
                            this.dictData = res.data;
                            this.handleSearch();
                        }
                    });
                }
            },
            immediate: true,
            deep: true
        }
    }
};
</script>
<style lang="less">
</style>